export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Учет: Список исторических справок",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
